<template>
<div class="edit-padding-box">
  <RichTextEditor
    :note="note"
    :uptitle="editBookorNoteTitle"
    :upcontent="editBookorNoteContent"
    :update="isUpdateBookorNote"
  ></RichTextEditor>

  <!-- 流程进度触发图标 -->
  <div class="flow-trigger-icon" @click="showFlowDialog = true">
    <i class="el-icon-s-operation"></i>
    <div class="icon-pulse"></div>
  </div>

  <!-- 流程进度弹窗 -->
  <ProcessFlowDialog :visible.sync="showFlowDialog" />
</div>
</template>

<script>
import RichTextEditor from '@/components/editor/rich-text-editor';
import request from '@/http/request';
import { Loading } from 'element-ui';
import ProcessFlowDialog from '@/components/process-flow/ProcessFlowDialog.vue';
import { mapState } from 'vuex';

export default {
  data () {
    return {
      editBookorNoteTitle: '',
      editBookorNoteContent: '',
      isUpdateBookorNote: false,
      loadingInstance: null,
      note: null,
      showFlowDialog: false // 流程图弹窗显示状态
    }
  },
  computed: {
    ...mapState('processFlow', ['isFlowActive'])
  },
  watch: {
    // 监听流程状态，自动打开弹窗
    isFlowActive (val) {
      if (val) {
        this.showFlowDialog = true
      }
    }
  },
  components: {
    RichTextEditor,
    ProcessFlowDialog
  },
  created () {
    this.$watch('$route.query', (newQuery) => {
      const origin = this.$route.query.origin
      if (origin === 'Crawling') {
        this.editBookorNoteContent = this.$store.state.urlContent
        return
      }
      if (!newQuery?.paperId) {
        // 新建文档时，清空标题和内容
        this.editBookorNoteTitle = ''
        this.editBookorNoteContent = ''
        this.note = null
        return
      }
      this.getWordMes(newQuery.paperId)
    })
  },
  props: ['noteContent'],
  methods: {
    getWordMes (paperId) {
      this.loadingInstance = Loading.service({
        fullscreen: true, // 是否全屏遮罩
        text: '加载中...', // 显示的文本
        background: 'rgba(0, 0, 0, 0.7)' // 遮罩的背景颜色
      })
      request('/api/Paper/getPaperInfo', {
        paper_id: paperId
      }).then((result) => {
        this.note = result
        this.editBookorNoteTitle = result.paper_title
        this.editBookorNoteContent = result.paper_url
        this.loadingInstance.close()
        this.$emit('getArticleData', {
          ...result,
          type: 'note',
          url: result.paper_url
        })
      }).catch(() => {
        this.loadingInstance.close()
      })
    },
    share() {
      this.paperId = this.$route.query.paperId
      const userId = this.$route.query.userId
      const userinfo = JSON.parse(localStorage.getItem('userinfo'))
      if (!userinfo) {
        return
      }
      if (userId && userId !== userinfo?.userId) {
        this.$confirm('有用户给你分享了一篇文章，是否接受该文章', '提示', {
          confirmButtonText: '接受',
          cancelButtonText: '不接受',
          type: 'warning'
        }).then(() => {
          // 说明是别人分享给我的
          request('/api/Paper/paperShare', {
            paper_id: this.paperId,
            member_ids: userinfo.userid.toString()
          }).then((res) => {
            this.dialogTableVisible = false
          }).catch((err) => {
            this.$message.error(err.message)
          })
        })
      }
    }
  },
  mounted() {
    const origin = this.$route.query.origin
    if (origin === 'Crawling') {
      this.editBookorNoteContent = this.$store.state.urlContent
      return
    }
    const paperId = this.$route.query.paperId
    if (!paperId) {
      // 新建文档时，清空标题和内容
      this.editBookorNoteTitle = ''
      if (this.noteContent) {
        this.editBookorNoteContent = this.noteContent
      } else {
        this.editBookorNoteContent = ''
      }
      return
    }
    this.getWordMes(paperId)
    this.share()
  }
}
</script>
<style lang="scss">
.edit-padding-box {
  position: relative;
  float: left;
  height: 100%;
  padding: 5px 0;
  width: 80vw;
  display: flex;
  justify-content: center;
}

// 流程进度触发图标样式
.flow-trigger-icon {
  position: fixed;
  right: 30px;
  bottom: 30px;
  width: 56px;
  height: 56px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1500;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  
  i {
    font-size: 26px;
    color: white;
    z-index: 2;
  }

  // 脉冲动画背景
  .icon-pulse {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    animation: pulse-ring 2s cubic-bezier(0.25, 0.8, 0.25, 1) infinite;
  }

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 30px rgba(102, 126, 234, 0.6);
    
    i {
      animation: icon-rotate 0.6s ease;
    }
  }

  &:active {
    transform: scale(0.95);
  }
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.2);
    opacity: 0.4;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

@keyframes icon-rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 600px) {
  .edit-padding-box {
    height: 100vh;
    width: 80vw;
  }
  .change-to-word {
    display: none;
  }
}
</style>
